import { Navigate } from "react-router-dom";
import useUserStore from "../hooks/useUserStore";

export const authService = {
  getToken: () => {
    const token = localStorage.getItem("token");
    if (token) {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload.exp < Date.now() / 1000) {
        localStorage.removeItem("token");
        return null;
      }
      return token;
    }
    return null;
  },

  setToken: (token) => {
    localStorage.setItem("token", token);
  },

  removeToken: () => {
    localStorage.removeItem("token");
  },

  isAuthenticated: () => {
    const token = localStorage.getItem("token");
    console.log(token);
    return !!token;
  },

  setUserData: (userData) => {
    const setUser = useUserStore.getState().setUser;
    setUser(userData);
    localStorage.setItem('userData', JSON.stringify(userData));
  },
  
  getUserData: () => {
    return useUserStore.getState().user;
  },

  getUsername: () => {
    const user = useUserStore.getState().user;
    return user ? user.name : null;
  },

  getUserRole: () => {
    const user = useUserStore.getState().user;
    return user ? user.role : null;
  },

  clearUserData: () => {
    useUserStore.getState().clearUser();
  },
};

export const ProtectedRoute = ({ element, allowedRoles }) => {
  const userRole = authService.getUserRole();
  if (!userRole) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/dashboard" />;
  }

  return element;
};
